import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@tds/core-button';

import Modal from '../shared/modal';

import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import {
  StatusBarWrapper,
  BoxWrapper,
  DueMonthlyWrapper,
  LabelDueMonthly,
  PricingBlockMain,
  BeforeTaxesLabel,
  DueNowWrapper,
  IntegralPart,
  modalStyles,
  ModalBottomContainer,
  DownloadQuoteMessageContainer,
  VerticalWrapper,
  HorizontalWrapper
} from './css';
import { formatCurrency } from '../../utils/currencyFormatter';
import { DiscountApplicationChip, DiscountApplicationChipNotch } from '../../form/css';

const getFormattedPricing = price => {
  return <IntegralPart>{formatCurrency(price)}</IntegralPart>;
};

const FmStatusBar = ({
  step,
  isLastStep,
  isFormTouched,
  onSaveAndExit,
  onProceedClick,
  onBackClick,
  showDownloadQuoteFooter,
  totalMonthly,
  totalOneTime,
  onQuoteDownload,
  isDiscountApplied,
  isFormSubmit
}) => {
  const localizedStrings = useLocalizedStringsContext();

  const {
    formButtons: {
      continueButtonLabel,
      backLabel,
      saveContinueLaterButtonLabel,
      submitButtonLabel
    }
  } = localizedStrings;

  const [
    isDownloadQuoteModalVisible,
    setIsDownloadQuoteModalVisible
  ] = useState(false);

  const onCloseDownloadQuoteModal = () => {
    setIsDownloadQuoteModalVisible(false);
  };

  const showDownloadQuoteModal = () => {
    setIsDownloadQuoteModalVisible(true);
  };

  return (
    <StatusBarWrapper>
      <div id="footer-wrapper">
        <BoxWrapper>
          <VerticalWrapper>
            <HorizontalWrapper>
              <DueMonthlyWrapper>
                <div>
                  <LabelDueMonthly>Due Monthly</LabelDueMonthly>
                  <PricingBlockMain>
                    {getFormattedPricing(totalMonthly)}
                  </PricingBlockMain>
                  <BeforeTaxesLabel>Before Taxes</BeforeTaxesLabel>
                </div>
              </DueMonthlyWrapper>
              <DueNowWrapper>
                <>
                  <div>
                    <LabelDueMonthly>Due Now</LabelDueMonthly>
                    <PricingBlockMain>
                      {getFormattedPricing(totalOneTime)}
                    </PricingBlockMain>
                    <BeforeTaxesLabel>Before Taxes</BeforeTaxesLabel>
                  </div>
                </>
              </DueNowWrapper>
            </HorizontalWrapper>
            {
              isDiscountApplied && 
              <DiscountApplicationChip>
                <DiscountApplicationChipNotch/>
                Discount Applied
              </DiscountApplicationChip>
            }
          </VerticalWrapper>
          {showDownloadQuoteFooter ? (
            <>
              <button
                type="button"
                onClick={() => {
                  showDownloadQuoteModal();
                  onQuoteDownload();
                }}
                style={{ marginLeft: '1em', height: '60px' }}
                className="frg-button color-purple"
              >
                Download the proposal (PDF)
              </button>
              <button
                type="button"
                onClick={e => onProceedClick(e)}
                style={{ marginLeft: '1em', height: '60px', marginTop: '1px' }}
                className="frg-button color-green"
              >
                Proceed with the order
              </button>
            </>
          ) : (
            <>
              {step !== 1 && (
                <button
                  type="button"
                  onClick={onBackClick}
                  className="frg-button color-green"
                >
                  {backLabel}
                </button>
              )}
              <button
                type="button"
                onClick={e => onSaveAndExit(e)}
                style={{ marginLeft: '1em', height: '60px' }}
                className="frg-button color-purple"
                disabled={!isFormTouched}
              >
                {saveContinueLaterButtonLabel}
              </button>
              <button
                disabled={isLastStep && !isFormSubmit}
                type="button"
                onClick={e => onProceedClick(e)}
                style={{ marginLeft: '1em', height: '60px', marginTop: '1px' }}
                className={`frg-button color-${
                  isLastStep ? 'purple' : 'green'
                }`}
              >
                {isLastStep ? submitButtonLabel : continueButtonLabel}
              </button>
            </>
          )}
        </BoxWrapper>
      </div>
      <Modal
        open={isDownloadQuoteModalVisible}
        setOpen={onCloseDownloadQuoteModal}
        customStyles={modalStyles}
        header="Download Proposal PDF"
      >
        <DownloadQuoteMessageContainer>
          Monthly Total value {getFormattedPricing(totalMonthly)}. Please update
          your Salesforce opportunity accordingly.
        </DownloadQuoteMessageContainer>
        <ModalBottomContainer>
          <Button onClick={onCloseDownloadQuoteModal} variant="secondary">
            Close
          </Button>
        </ModalBottomContainer>
      </Modal>
    </StatusBarWrapper>
  );
};

FmStatusBar.propTypes = {
  step: PropTypes.number.isRequired,
  isLastStep: PropTypes.bool.isRequired,
  isFormTouched: PropTypes.bool.isRequired,
  onSaveAndExit: PropTypes.func.isRequired,
  onProceedClick: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired,
  showDownloadQuoteFooter: PropTypes.bool.isRequired,
  totalMonthly: PropTypes.number.isRequired,
  totalOneTime: PropTypes.number.isRequired,
  onQuoteDownload: PropTypes.func.isRequired,
  isDiscountApplied: PropTypes.bool.isRequired,
  isFormSubmit: PropTypes.bool.isRequired,
};

FmStatusBar.defaultProps = {};

export default FmStatusBar;
